import { useContext } from "react";
import QuickbooksContext from "../contexts/QuickbooksContext";

const useQuickbooks = () => useContext(QuickbooksContext);

export default useQuickbooks;
